import {
  GetAllSmartInterviewOutput,
  SmartInterviewsBuilder,
} from '../smart-interviews.types';

export const getAllSmartInterviews = (builder: SmartInterviewsBuilder) =>
  builder.query<GetAllSmartInterviewOutput, void>({
    query: () => ({
      url: `/smart-interview-questions`,
      method: 'GET',
    }),
    providesTags: () => [{ type: 'SmartInterviews' }],
  });
